module.exports = __webpack_public_path__ + "img/miller-high-life-icon.ee47c3fa.png";